// extracted by mini-css-extract-plugin
export var arrow = "_21-4";
export var arrowButton = "_21-6";
export var columnResizer = "_21-a";
export var columnResizerActive = "_21-b";
export var columnResizerIndicator = "_21-c";
export var columnResizerIndicatorActive = "_21-d";
export var headerCell = "_21-0";
export var help = "_21-3";
export var hoverArrow = "_21-5";
export var icon = "_21-2";
export var iconButton = "_21-9";
export var iconWrapper = "_21-8";
export var noBorder = "_21-e";
export var sortableHeaderCell = "_21-1";
export var textButton = "_21-7";